export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'FLUX AI 图像生成器 - 免费文本转图像在线',
        pageDescription: 'Flux 是由 Black Forest Labs 开发的一款强大的 AI 图像生成器，Black Forest Labs 是一家由热门 Stable Diffusion 模型背后的团队创立的初创公司。Flux AI 拥有120 亿个参数和独特的设计，能够提供更好的视觉质量，更准确地遵循提示，并且整体性能优于其他模型。您可以在 WeryAI 免费试用 Flux！',
        pageKeywords: 'FLUX, Black Forest Labs, AI 图像生成, AI 绘画, 人工智能, 图像编辑, 创意表达, 文本转图像',

        // Open Graph
        ogTitle: 'FLUX AI 图像生成器 - 免费文本转图像在线',
        ogDescription: '体验 FLUX AI 图像生成器，Black Forest Labs 开发的最先进 AI 图像生成模型。',

        // Twitter Card
        twitterTitle: 'FLUX AI 图像生成器 - 免费文本转图像在线',
        twitterDescription: '体验 FLUX AI 图像生成器，Black Forest Labs 开发的最先进 AI 图像生成模型。',

        // 生成器部分
        generatorTitle: 'FLUX AI 图像生成器',
        generatorDescription: 'WeryAI 现已深度集成FLUX模型，Flux 是由 Black Forest Labs 开发的一款强大的 AI 图像生成器，Black Forest Labs 是一家由热门 Stable Diffusion 模型背后的团队创立的初创公司。Flux AI 拥有120 亿个参数和独特的设计，能够提供更好的视觉质量，更准确地遵循提示，并且整体性能优于其他模型。您可以在 WeryAI 免费试用 Flux！',

        // 核心功能部分
        coreFeaturesTitle: 'FLUX 核心功能特性',
        coreFeaturesSubtitle: '探索 FLUX AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // 革命性的文本到图像技术
        revolutionaryTextToImageTitle: '革命性的文本到图像技术',
        revolutionaryTextToImageDescription: '生成高度精细的图像，并采用多种艺术风格，同时严格遵循提示。',

        // 创意表达
        creativeExpressionTitle: '创意表达',
        creativeExpressionDescription: '在迭代变化中保持角色和场景元素以确保一致性。无论生成多少张图像，角色的外观、特征和风格都保持完美统一。',

        // 高级风格控制
        advancedStyleControlTitle: '高级风格控制',
        advancedStyleControlDescription: '使用纯文本实现高级图像编辑。通过简单的文字描述，您可以精确调整图像的细节、颜色、风格和构图。',

        // 高分辨率输出
        highResolutionTitle: '高分辨率输出',
        highResolutionDescription: '支持高达200万像素的图像生成，并提供多种宽高比。',

        // 快速处理
        fastProcessingTitle: '快速处理',
        fastProcessingDescription: '几秒钟内生成专业级图像。FLUX 的优化算法确保您能够快速获得高质量的图像结果，大大提升创作效率。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 FLUX 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube 视频部分
        youtubeTitle: '关于 FLUX AI 图像模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 FLUX AI 图像模型的 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '在 WeryAI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: '什么是 FLUX?',
        faq1Answer: 'FLUX 是 Black Forest Labs 开发的最先进 AI 图像生成模型，具备卓越的图像质量和创意表达能力，能够生成具有专业级质量的图像。',
        faq2Question: 'FLUX 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'FLUX 在图像质量、创意表达、风格控制和多模态融合方面具有显著优势。它能够生成高质量的专业级图像，并支持复杂的创意表达。',
        faq3Question: '我能免费使用 FLUX 吗?',
        faq3Answer: '是的。FLUX 通过 WeryAI 的免费试用提供有限的免费额度。如需大量使用,则需要升级。',
        faq4Question: 'FLUX 支持哪些图像格式?',
        faq4Answer: 'FLUX 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',
        faq5Question: '我可以使用 FLUX 用于商业项目吗?',
        faq5Answer: '是的。FLUX 的高精度图像生成和创意表达能力使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 FLUX，将您的创意转化为精彩图像',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    en: {
        // Page title and description
        pageTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        pageDescription: 'FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        ogDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Twitter Card
        twitterTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        twitterDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Generator section
        generatorTitle: 'FLUX AI Image Generator',
        generatorDescription: 'WeryAI now deeply integrates the FLUX model, FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',

        // Core features section
        coreFeaturesTitle: 'FLUX Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX AI image generator and embark on a revolutionary AI image creation journey',

        // Revolutionary Text-to-Image Technology
        revolutionaryTextToImageTitle: 'Revolutionary Text-to-Image Technology',
        revolutionaryTextToImageDescription: 'Generate highly refined images in various artistic styles while strictly following prompts.',

        // Creative Expression
        creativeExpressionTitle: 'Creative Expression',
        creativeExpressionDescription: 'Maintain character and scene elements across iterations for consistency. Character appearance, features, and style remain perfectly unified across any number of generated images.',

        // Advanced Style Control
        advancedStyleControlTitle: 'Advanced Style Control',
        advancedStyleControlDescription: 'Achieve advanced image editing with pure text. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',

        // High Resolution Output
        highResolutionTitle: 'High Resolution Output',
        highResolutionDescription: 'Supports image generation up to 2 megapixels with various aspect ratios.',

        // Fast Processing
        fastProcessingTitle: 'Fast Processing',
        fastProcessingDescription: 'Generate professional-grade images in seconds. FLUX\'s optimized algorithms ensure you can quickly obtain high-quality image results, greatly improving creative efficiency.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose FLUX model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About FLUX AI Image Model',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX AI Image Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is FLUX?',
        faq1Answer: 'FLUX is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of FLUX compared to other image generation models?',
        faq2Answer: 'FLUX has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use FLUX for free?',
        faq3Answer: 'Yes. FLUX offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does FLUX support?',
        faq4Answer: 'FLUX supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use FLUX for commercial projects?',
        faq5Answer: 'Yes. FLUX\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience FLUX now and transform your creativity into amazing images',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ja: {
        // 日语翻译
        pageTitle: 'FLUX AI画像ジェネレーター - 無料のテキストから画像へオンライン',
        pageDescription: 'FLUXは、Stable Diffusionの背後にあるチームによって設立されたBlack Forest Labsが開発した強力なAI画像ジェネレーターです。120億のパラメータとユニークなデザインにより、FLUXは優れた視覚品質、プロンプト精度、全体的なパフォーマンスを提供します。WeryAIで無料でお試しください！',
        pageKeywords: 'FLUX, Black Forest Labs, AI画像生成, AIアート, 人工知能, 画像編集, クリエイティブ表現, テキストから画像',
        ogTitle: 'FLUX AI画像ジェネレーター - 無料のテキストから画像へオンライン',
        ogDescription: 'Black Forest Labsが開発した最先端のAI画像生成モデル、FLUX AI画像ジェネレーターを体験してください。',
        twitterTitle: 'FLUX AI画像ジェネレーター - 無料のテキストから画像へオンライン',
        twitterDescription: 'Black Forest Labsが開発した最先端のAI画像生成モデル、FLUX AI画像ジェネレーターを体験してください。',
        generatorTitle: 'FLUX AI画像ジェネレーター',
        generatorDescription: 'WeryAI はFLUXモデルを深く統合し、FLUXは、Stable Diffusionの背後にあるチームによって設立されたBlack Forest Labsが開発した強力なAI画像ジェネレーターです。120億のパラメータとユニークなデザインにより、FLUXは優れた視覚品質、プロンプト精度、全体的なパフォーマンスを提供します。WeryAIで無料でお試しください！',
        coreFeaturesTitle: 'FLUXの主な機能',
        coreFeaturesSubtitle: 'FLUX AI画像ジェネレーターの主な機能を探索し、革新的なAI画像作成の旅に出ましょう',
        revolutionaryTextToImageTitle: '革新的なテキストから画像へのテクノロジー',
        revolutionaryTextToImageDescription: 'プロンプトに厳密に従いながら、様々な芸術スタイルで高度に洗練された画像を生成します。',
        creativeExpressionTitle: 'クリエイティブ表現',
        creativeExpressionDescription: '反復処理全体でキャラクターとシーン要素を維持し、一貫性を保ちます。キャラクターの外観、特徴、スタイルは、生成された画像の数に関係なく完全に統一されたままです。',
        advancedStyleControlTitle: '高度なスタイルコントロール',
        advancedStyleControlDescription: '純粋なテキストで高度な画像編集を実現します。簡単なテキスト説明を通じて、画像の詳細、色、スタイル、構図を正確に調整できます。',
        highResolutionTitle: '高解像度出力',
        highResolutionDescription: '様々なアスペクト比で最大200万ピクセルの画像生成をサポートします。',
        fastProcessingTitle: '高速処理',
        fastProcessingDescription: '数秒でプロフェッショナルグレードの画像を生成します。FLUXの最適化されたアルゴリズムにより、高品質な画像結果を迅速に取得でき、クリエイティブ効率が大幅に向上します。',
        howToUseTitle: '使い方',
        howToUseSubtitle: '簡単3ステップで開始',
        step1Title: 'モデルを選択',
        step1Description: 'AI画像ツールでFLUXモデルを選択',
        step2Title: 'コンテンツを入力',
        step2Description: 'プロンプトを入力または参照画像をアップロード',
        step3Title: '画像を生成',
        step3Description: '生成ボタンをクリックし、待機して画像をダウンロード',
        youtubeTitle: 'FLUX AI画像モデルについてのYouTube動画',
        xPostsTitle: 'FLUX AI画像モデルについてのX投稿',
        exploreModelsTitle: 'WeryAIで他のAI画像モデルを探索',
        model1Title: 'Google Nano Banana AI画像ジェネレーター',
        model2Title: 'Google Imagen AI画像ジェネレーター',
        model3Title: 'Qwen Image AI画像ジェネレーター',
        faqTitle: 'よくある質問',
        faq1Question: 'FLUXとは何ですか？',
        faq1Answer: 'FLUXは、Black Forest Labsが開発した最先端のAI画像生成モデルで、プロフェッショナルグレードの画像を生成できる卓越した画像品質とクリエイティブ表現機能を備えています。',
        faq2Question: 'FLUXは他の画像生成モデルと比べてどのような利点がありますか？',
        faq2Answer: 'FLUXは、画像品質、クリエイティブ表現、スタイルコントロール、マルチモーダル融合において大きな利点があります。高品質なプロフェッショナルグレードの画像を生成でき、複雑なクリエイティブ表現をサポートします。',
        faq3Question: 'FLUXを無料で使用できますか？',
        faq3Answer: 'はい。FLUXはWeryAIの無料トライアルを通じて限定的な無料クレジットを提供しています。大量使用の場合はアップグレードが必要です。',
        faq4Question: 'FLUXはどのような画像形式をサポートしていますか？',
        faq4Answer: 'FLUXはJPG、PNG、WEBPなどの一般的な形式を含む様々な画像形式をサポートしています。生成された画像は高品質で豊富な詳細を特徴としています。',
        faq5Question: 'FLUXを商業プロジェクトに使用できますか？',
        faq5Answer: 'はい。FLUXの高精度画像生成とクリエイティブ表現機能は、高品質なAI生成画像を求めるデザイナー、アーティスト、コンテンツクリエーターにとって強力な選択肢となります。',
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription: '今すぐFLUXを体験し、あなたの創造性を素晴らしい画像に変換',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ko: {
        // 韩语翻译
        pageTitle: 'FLUX AI 이미지 생성기 - 무료 텍스트에서 이미지로 온라인',
        pageDescription: 'FLUX는 Stable Diffusion 뒤에 있는 팀이 설립한 Black Forest Labs에서 개발한 강력한 AI 이미지 생성기입니다. 120억 개의 파라미터와 독특한 디자인으로 FLUX는 우수한 시각적 품질, 프롬프트 정확도 및 전반적인 성능을 제공합니다. WeryAI에서 무료로 체험해보세요!',
        pageKeywords: 'FLUX, Black Forest Labs, AI 이미지 생성, AI 아트, 인공지능, 이미지 편집, 창의적 표현, 텍스트에서 이미지',
        ogTitle: 'FLUX AI 이미지 생성기 - 무료 텍스트에서 이미지로 온라인',
        ogDescription: 'Black Forest Labs에서 개발한 가장 진보된 AI 이미지 생성 모델인 FLUX AI 이미지 생성기를 체험하세요.',
        twitterTitle: 'FLUX AI 이미지 생성기 - 무료 텍스트에서 이미지로 온라인',
        twitterDescription: 'Black Forest Labs에서 개발한 가장 진보된 AI 이미지 생성 모델인 FLUX AI 이미지 생성기를 체험하세요.',
        generatorTitle: 'FLUX AI 이미지 생성기',
        generatorDescription: 'WeryAI는 이제 FLUX 모델을 심층 통합하여, FLUX는 Stable Diffusion 뒤에 있는 팀이 설립한 Black Forest Labs에서 개발한 강력한 AI 이미지 생성기입니다. 120억 개의 파라미터와 독특한 디자인으로 FLUX는 우수한 시각적 품질, 프롬프트 정확도 및 전반적인 성능을 제공합니다. WeryAI에서 무료로 체험해보세요!',
        coreFeaturesTitle: 'FLUX의 주요 기능',
        coreFeaturesSubtitle: 'FLUX AI 이미지 생성기의 주요 기능을 탐색하고 혁신적인 AI 이미지 제작 여정을 시작하세요',
        revolutionaryTextToImageTitle: '혁신적인 텍스트에서 이미지 기술',
        revolutionaryTextToImageDescription: '프롬프트를 엄격하게 따르면서 다양한 예술 스타일로 고도로 세련된 이미지를 생성합니다.',
        creativeExpressionTitle: '창의적 표현',
        creativeExpressionDescription: '일관성을 위해 반복 작업 전체에서 캐릭터와 장면 요소를 유지합니다. 캐릭터 외관, 특징, 스타일은 생성된 이미지 수에 관계없이 완벽하게 통일됩니다.',
        advancedStyleControlTitle: '고급 스타일 제어',
        advancedStyleControlDescription: '순수한 텍스트로 고급 이미지 편집을 달성합니다. 간단한 텍스트 설명을 통해 이미지 세부사항, 색상, 스타일, 구성을 정확하게 조정할 수 있습니다.',
        highResolutionTitle: '고해상도 출력',
        highResolutionDescription: '다양한 종횡비로 최대 200만 픽셀의 이미지 생성을 지원합니다.',
        fastProcessingTitle: '빠른 처리',
        fastProcessingDescription: '몇 초 만에 전문가급 이미지를 생성합니다. FLUX의 최적화된 알고리즘은 고품질 이미지 결과를 빠르게 얻을 수 있도록 보장하여 창의적 효율성을 크게 향상시킵니다.',
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계로 시작',
        step1Title: '모델 선택',
        step1Description: 'AI 이미지 도구에서 FLUX 모델 선택',
        step2Title: '콘텐츠 입력',
        step2Description: '프롬프트 입력 또는 참조 이미지 업로드',
        step3Title: '이미지 생성',
        step3Description: '생성 버튼 클릭, 대기 후 이미지 다운로드',
        youtubeTitle: 'FLUX AI 이미지 모델에 대한 YouTube 비디오',
        xPostsTitle: 'FLUX AI 이미지 모델에 대한 X 게시물',
        exploreModelsTitle: 'WeryAI에서 다른 AI 이미지 모델 탐색',
        model1Title: 'Google Nano Banana AI 이미지 생성기',
        model2Title: 'Google Imagen AI 이미지 생성기',
        model3Title: 'Qwen Image AI 이미지 생성기',
        faqTitle: '자주 묻는 질문',
        faq1Question: 'FLUX가 무엇인가요?',
        faq1Answer: 'FLUX는 Black Forest Labs에서 개발한 가장 진보된 AI 이미지 생성 모델로, 전문가급 이미지를 생성할 수 있는 탁월한 이미지 품질과 창의적 표현 기능을 갖추고 있습니다.',
        faq2Question: 'FLUX는 다른 이미지 생성 모델에 비해 어떤 장점이 있나요?',
        faq2Answer: 'FLUX는 이미지 품질, 창의적 표현, 스타일 제어, 멀티모달 융합에서 큰 장점이 있습니다. 고품질의 전문가급 이미지를 생성할 수 있으며 복잡한 창의적 표현을 지원합니다.',
        faq3Question: 'FLUX를 무료로 사용할 수 있나요?',
        faq3Answer: '네. FLUX는 WeryAI의 무료 체험을 통해 제한된 무료 크레딧을 제공합니다. 광범위한 사용을 위해서는 업그레이드가 필요합니다.',
        faq4Question: 'FLUX는 어떤 이미지 형식을 지원하나요?',
        faq4Answer: 'FLUX는 JPG, PNG, WEBP 등 일반적인 형식을 포함한 다양한 이미지 형식을 지원합니다. 생성된 이미지는 고품질과 풍부한 디테일을 특징으로 합니다.',
        faq5Question: 'FLUX를 상업 프로젝트에 사용할 수 있나요?',
        faq5Answer: '네. FLUX의 고정밀 이미지 생성과 창의적 표현 기능은 고품질 AI 생성 이미지를 찾는 디자이너, 아티스트, 콘텐츠 크리에이터에게 강력한 선택이 됩니다.',
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 FLUX를 체험하고 당신의 창의성을 놀라운 이미지로 변환하세요',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'FLUX AI 圖像產生器 - 免費在線文生圖',
        pageDescription: 'Flux 是由 Black Forest Labs 开发的一款强大的 AI 图像生成器，Black Forest Labs 是一家由热门 Stable Diffusion 模型背后的团队创立的初创公司。Flux AI 拥有120 亿个参数和独特的设计，能够提供更好的视觉质量，更准确地遵循提示，并且整体性能优于其他模型。您可以在 WeryAI 免费试用 Flux！',
        pageKeywords: 'FLUX, Black Forest Labs, AI 图像生成, AI 绘画, 人工智能, 图像编辑, 创意表达, 文本转图像',

        // Open Graph
        ogTitle: 'FLUX AI 图像生成器 - 免费文本转图像在线',
        ogDescription: '体验 FLUX AI 图像生成器，Black Forest Labs 开发的最先进 AI 图像生成模型。',

        // Twitter Card
        twitterTitle: 'FLUX AI 图像生成器 - 免费文本转图像在线',
        twitterDescription: '体验 FLUX AI 图像生成器，Black Forest Labs 开发的最先进 AI 图像生成模型。',

        // 生成器部分
        generatorTitle: 'FLUX AI 圖像產生器',
        generatorDescription: 'WeryAI 現已深度整合FLUX模型，FLUX 是由 Black Forest Labs 開發的強大 AI 圖像產生器，由 Stable Diffusion 原班人馬打造。具備 120 億參數，提供卓越的視覺品質、提示語準確性及整體性能。立即在 WeryAI 免費體驗 FLUX！',

        // 核心功能部分
        coreFeaturesTitle: 'FLUX 核心功能',
        coreFeaturesSubtitle: '探索 FLUX AI 图像生成器的核心功能，开启革命性的 AI 图像创作之旅',

        // 革命性的文本到图像技术
        revolutionaryTextToImageTitle: '革命性文生圖技術',
        revolutionaryTextToImageDescription: '生成高度精细的图像，并采用多种艺术风格，同时严格遵循提示。',

        // 创意表达
        creativeExpressionTitle: '創意表達與一致性',
        creativeExpressionDescription: '在迭代变化中保持角色和场景元素以确保一致性。无论生成多少张图像，角色的外观、特征和风格都保持完美统一。',

        // 高级风格控制
        advancedStyleControlTitle: '高级风格控制',
        advancedStyleControlDescription: '使用纯文本实现高级图像编辑。通过简单的文字描述，您可以精确调整图像的细节、颜色、风格和构图。',

        // 高分辨率输出
        highResolutionTitle: '高分辨率输出',
        highResolutionDescription: '支持高达200万像素的图像生成，并提供多种宽高比。',

        // 快速处理
        fastProcessingTitle: '極速處理',
        fastProcessingDescription: '几秒钟内生成专业级图像。FLUX 的优化算法确保您能够快速获得高质量的图像结果，大大提升创作效率。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择模型',
        step1Description: '在 AI 图像工具中选择 FLUX 模型',
        step2Title: '输入内容',
        step2Description: '输入提示词或上传参考图像',
        step3Title: '生成图像',
        step3Description: '点击生成按钮，等待并下载您的图像',

        // YouTube 视频部分
        youtubeTitle: '关于 FLUX AI 图像模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 FLUX AI 图像模型的 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '在 WeryAI 上探索其他 AI 图像模型',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ 部分
        faqTitle: '常见问题解答',
        faq1Question: '什么是 FLUX?',
        faq1Answer: 'FLUX 是 Black Forest Labs 开发的最先进 AI 图像生成模型，具备卓越的图像质量和创意表达能力，能够生成具有专业级质量的图像。',
        faq2Question: 'FLUX 与其他图像生成模型相比有哪些优势?',
        faq2Answer: 'FLUX 在图像质量、创意表达、风格控制和多模态融合方面具有显著优势。它能够生成高质量的专业级图像，并支持复杂的创意表达。',
        faq3Question: '我能免费使用 FLUX 吗?',
        faq3Answer: '是的。FLUX 通过 WeryAI 的免费试用提供有限的免费额度。如需大量使用,则需要升级。',
        faq4Question: 'FLUX 支持哪些图像格式?',
        faq4Answer: 'FLUX 支持多种图像格式，包括 JPG、PNG、WEBP 等常见格式。生成的图像具有高质量和丰富的细节表现。',
        faq5Question: '我可以使用 FLUX 用于商业项目吗?',
        faq5Answer: '是的。FLUX 的高精度图像生成和创意表达能力使其成为设计师、艺术家和内容创作者寻求高质量 AI 生成图像的有力选择。',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 FLUX，将您的创意转化为精彩图像',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    pl: {

        // Page title and description
        pageTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        pageDescription: 'FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        ogDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Twitter Card
        twitterTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        twitterDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Generator section
        generatorTitle: 'FLUX AI Image Generator',
        generatorDescription: 'WeryAI jest teraz głęboko zintegrowane z modelem FLUX, FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',

        // Core features section
        coreFeaturesTitle: 'FLUX Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX AI image generator and embark on a revolutionary AI image creation journey',

        // Revolutionary Text-to-Image Technology
        revolutionaryTextToImageTitle: 'Revolutionary Text-to-Image Technology',
        revolutionaryTextToImageDescription: 'Generate highly refined images in various artistic styles while strictly following prompts.',

        // Creative Expression
        creativeExpressionTitle: 'Creative Expression',
        creativeExpressionDescription: 'Maintain character and scene elements across iterations for consistency. Character appearance, features, and style remain perfectly unified across any number of generated images.',

        // Advanced Style Control
        advancedStyleControlTitle: 'Advanced Style Control',
        advancedStyleControlDescription: 'Achieve advanced image editing with pure text. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',

        // High Resolution Output
        highResolutionTitle: 'High Resolution Output',
        highResolutionDescription: 'Supports image generation up to 2 megapixels with various aspect ratios.',

        // Fast Processing
        fastProcessingTitle: 'Fast Processing',
        fastProcessingDescription: 'Generate professional-grade images in seconds. FLUX\'s optimized algorithms ensure you can quickly obtain high-quality image results, greatly improving creative efficiency.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose FLUX model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About FLUX AI Image Model',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX AI Image Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is FLUX?',
        faq1Answer: 'FLUX is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of FLUX compared to other image generation models?',
        faq2Answer: 'FLUX has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use FLUX for free?',
        faq3Answer: 'Yes. FLUX offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does FLUX support?',
        faq4Answer: 'FLUX supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use FLUX for commercial projects?',
        faq5Answer: 'Yes. FLUX\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience FLUX now and transform your creativity into amazing images',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    es: {
        // Español
        pageTitle: 'Generador de Imágenes AI FLUX - Texto a Imagen Gratis en Línea',
        pageDescription: 'FLUX es un potente generador de imágenes AI desarrollado por Black Forest Labs, fundado por el equipo detrás de Stable Diffusion. Con 12 mil millones de parámetros y diseño único, FLUX ofrece calidad visual superior, precisión de prompts y rendimiento general. ¡Prueba FLUX gratis en WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, generación de imágenes AI, arte AI, inteligencia artificial, edición de imágenes, expresión creativa, texto a imagen',
        ogTitle: 'Generador de Imágenes AI FLUX - Texto a Imagen Gratis en Línea',
        ogDescription: 'Experimenta el generador de imágenes AI FLUX, el modelo de generación de imágenes AI más avanzado desarrollado por Black Forest Labs.',
        twitterTitle: 'Generador de Imágenes AI FLUX - Texto a Imagen Gratis en Línea',
        twitterDescription: 'Experimenta el generador de imágenes AI FLUX, el modelo de generación de imágenes AI más avanzado desarrollado por Black Forest Labs.',
        generatorTitle: 'Generador de Imágenes AI FLUX',
        generatorDescription: 'WeryAI ahora integra profundamente el modelo FLUX, FLUX es un potente generador de imágenes AI desarrollado por Black Forest Labs, fundado por el equipo detrás de Stable Diffusion. Con 12 mil millones de parámetros y diseño único, FLUX ofrece calidad visual superior, precisión de prompts y rendimiento general. ¡Prueba FLUX gratis en WeryAI!',
        coreFeaturesTitle: 'Características Principales de FLUX',
        coreFeaturesSubtitle: 'Explora las características principales del generador de imágenes AI FLUX y embarca en un viaje revolucionario de creación de imágenes AI',
        revolutionaryTextToImageTitle: 'Tecnología Revolucionaria de Texto a Imagen',
        revolutionaryTextToImageDescription: 'Genera imágenes altamente refinadas en varios estilos artísticos mientras sigue estrictamente los prompts.',
        creativeExpressionTitle: 'Expresión Creativa',
        creativeExpressionDescription: 'Mantiene personajes y elementos de escena a través de iteraciones para consistencia. La apariencia, características y estilo del personaje permanecen perfectamente unificados en cualquier número de imágenes generadas.',
        advancedStyleControlTitle: 'Control de Estilo Avanzado',
        advancedStyleControlDescription: 'Logra edición avanzada de imágenes con texto puro. A través de descripciones de texto simples, puedes ajustar con precisión detalles de imagen, colores, estilos y composición.',
        highResolutionTitle: 'Salida de Alta Resolución',
        highResolutionDescription: 'Soporta generación de imágenes hasta 2 megapíxeles con varias relaciones de aspecto.',
        fastProcessingTitle: 'Procesamiento Rápido',
        fastProcessingDescription: 'Genera imágenes de grado profesional en segundos. Los algoritmos optimizados de FLUX aseguran que puedas obtener resultados de imágenes de alta calidad rápidamente, mejorando enormemente la eficiencia creativa.',
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres pasos simples para comenzar',
        step1Title: 'Seleccionar Modelo',
        step1Description: 'Elige el modelo FLUX en herramientas de imagen AI',
        step2Title: 'Ingresar Contenido',
        step2Description: 'Ingresa prompts o sube imágenes de referencia',
        step3Title: 'Generar Imagen',
        step3Description: 'Haz clic en el botón generar, espera y descarga tu imagen',
        youtubeTitle: 'Videos de YouTube Sobre el Modelo de Imagen AI FLUX',
        xPostsTitle: 'Publicaciones de X Sobre el Modelo de Imagen AI FLUX',
        exploreModelsTitle: 'Explora Otros Modelos de Imagen AI en WeryAI',
        model1Title: 'Generador de Imágenes AI Google Nano Banana',
        model2Title: 'Generador de Imágenes AI Google Imagen',
        model3Title: 'Generador de Imágenes AI Qwen Image',
        faqTitle: 'Preguntas Frecuentes',
        faq1Question: '¿Qué es FLUX?',
        faq1Answer: 'FLUX es el modelo de generación de imágenes AI más avanzado desarrollado por Black Forest Labs, con calidad de imagen excepcional y capacidades de expresión creativa que pueden generar imágenes de grado profesional.',
        faq2Question: '¿Cuáles son las ventajas de FLUX en comparación con otros modelos de generación de imágenes?',
        faq2Answer: 'FLUX tiene ventajas significativas en calidad de imagen, expresión creativa, control de estilo y fusión multimodal. Puede generar imágenes de grado profesional de alta calidad y soporta expresión creativa compleja.',
        faq3Question: '¿Puedo usar FLUX gratis?',
        faq3Answer: 'Sí. FLUX ofrece créditos gratuitos limitados a través de la prueba gratuita de WeryAI. Para uso extensivo, se requiere una actualización.',
        faq4Question: '¿Qué formatos de imagen soporta FLUX?',
        faq4Answer: 'FLUX soporta varios formatos de imagen incluyendo JPG, PNG, WEBP y otros formatos comunes. Las imágenes generadas presentan alta calidad y detalles ricos.',
        faq5Question: '¿Puedo usar FLUX para proyectos comerciales?',
        faq5Answer: 'Sí. Las capacidades de generación de imágenes de alta precisión y expresión creativa de FLUX lo convierten en una opción poderosa para diseñadores, artistas y creadores de contenido que buscan imágenes generadas por AI de alta calidad.',
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription: 'Experimenta FLUX ahora y transforma tu creatividad en imágenes asombrosas',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    fr: {
        // Français
        pageTitle: 'Générateur d\'Images IA FLUX - Texte vers Image Gratuit en Ligne',
        pageDescription: 'FLUX est un puissant générateur d\'images IA développé par Black Forest Labs, fondé par l\'équipe derrière Stable Diffusion. Avec 12 milliards de paramètres et un design unique, FLUX offre une qualité visuelle supérieure, une précision des prompts et des performances globales. Essayez FLUX gratuitement sur WeryAI !',
        pageKeywords: 'FLUX, Black Forest Labs, génération d\'images IA, art IA, intelligence artificielle, édition d\'images, expression créative, texte vers image',
        ogTitle: 'Générateur d\'Images IA FLUX - Texte vers Image Gratuit en Ligne',
        ogDescription: 'Découvrez le générateur d\'images IA FLUX, le modèle de génération d\'images IA le plus avancé développé par Black Forest Labs.',
        twitterTitle: 'Générateur d\'Images IA FLUX - Texte vers Image Gratuit en Ligne',
        twitterDescription: 'Découvrez le générateur d\'images IA FLUX, le modèle de génération d\'images IA le plus avancé développé par Black Forest Labs.',
        generatorTitle: 'Générateur d\'Images IA FLUX',
        generatorDescription: 'WeryAI intègre désormais en profondeur le modèle FLUX, FLUX est un puissant générateur d\'images IA développé par Black Forest Labs, fondé par l\'équipe derrière Stable Diffusion. Avec 12 milliards de paramètres et un design unique, FLUX offre une qualité visuelle supérieure, une précision des prompts et des performances globales. Essayez FLUX gratuitement sur WeryAI !',
        coreFeaturesTitle: 'Caractéristiques Principales de FLUX',
        coreFeaturesSubtitle: 'Explorez les caractéristiques principales du générateur d\'images IA FLUX et embarquez dans un voyage révolutionnaire de création d\'images IA',
        revolutionaryTextToImageTitle: 'Technologie Révolutionnaire de Texte vers Image',
        revolutionaryTextToImageDescription: 'Générez des images hautement raffinées dans divers styles artistiques tout en suivant strictement les prompts.',
        creativeExpressionTitle: 'Expression Créative',
        creativeExpressionDescription: 'Maintenez les personnages et les éléments de scène à travers les itérations pour la cohérence. L\'apparence, les caractéristiques et le style du personnage restent parfaitement unifiés sur n\'importe quel nombre d\'images générées.',
        advancedStyleControlTitle: 'Contrôle de Style Avancé',
        advancedStyleControlDescription: 'Réalisez une édition d\'images avancée avec du texte pur. Grâce à de simples descriptions textuelles, vous pouvez ajuster avec précision les détails de l\'image, les couleurs, les styles et la composition.',
        highResolutionTitle: 'Sortie Haute Résolution',
        highResolutionDescription: 'Prend en charge la génération d\'images jusqu\'à 2 mégapixels avec divers rapports d\'aspect.',
        fastProcessingTitle: 'Traitement Rapide',
        fastProcessingDescription: 'Générez des images de qualité professionnelle en quelques secondes. Les algorithmes optimisés de FLUX garantissent que vous pouvez obtenir rapidement des résultats d\'images de haute qualité, améliorant considérablement l\'efficacité créative.',
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples pour commencer',
        step1Title: 'Sélectionner le Modèle',
        step1Description: 'Choisissez le modèle FLUX dans les outils d\'image IA',
        step2Title: 'Saisir le Contenu',
        step2Description: 'Entrez des prompts ou téléchargez des images de référence',
        step3Title: 'Générer l\'Image',
        step3Description: 'Cliquez sur le bouton générer, attendez et téléchargez votre image',
        youtubeTitle: 'Vidéos YouTube Sur le Modèle d\'Image IA FLUX',
        xPostsTitle: 'Publications X Sur le Modèle d\'Image IA FLUX',
        exploreModelsTitle: 'Explorez d\'Autres Modèles d\'Image IA sur WeryAI',
        model1Title: 'Générateur d\'Images IA Google Nano Banana',
        model2Title: 'Générateur d\'Images IA Google Imagen',
        model3Title: 'Générateur d\'Images IA Qwen Image',
        faqTitle: 'Questions Fréquemment Posées',
        faq1Question: 'Qu\'est-ce que FLUX ?',
        faq1Answer: 'FLUX est le modèle de génération d\'images IA le plus avancé développé par Black Forest Labs, avec une qualité d\'image exceptionnelle et des capacités d\'expression créative qui peuvent générer des images de qualité professionnelle.',
        faq2Question: 'Quels sont les avantages de FLUX par rapport aux autres modèles de génération d\'images ?',
        faq2Answer: 'FLUX présente des avantages significatifs en matière de qualité d\'image, d\'expression créative, de contrôle de style et de fusion multimodale. Il peut générer des images de qualité professionnelle de haute qualité et prend en charge une expression créative complexe.',
        faq3Question: 'Puis-je utiliser FLUX gratuitement ?',
        faq3Answer: 'Oui. FLUX offre des crédits gratuits limités via l\'essai gratuit de WeryAI. Pour une utilisation intensive, une mise à niveau est requise.',
        faq4Question: 'Quels formats d\'image FLUX prend-il en charge ?',
        faq4Answer: 'FLUX prend en charge divers formats d\'image, notamment JPG, PNG, WEBP et d\'autres formats courants. Les images générées présentent une haute qualité et des détails riches.',
        faq5Question: 'Puis-je utiliser FLUX pour des projets commerciaux ?',
        faq5Answer: 'Oui. Les capacités de génération d\'images haute précision et d\'expression créative de FLUX en font un choix puissant pour les designers, artistes et créateurs de contenu recherchant des images générées par IA de haute qualité.',
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Découvrez FLUX maintenant et transformez votre créativité en images étonnantes',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    de: {
        // Deutsch
        pageTitle: 'FLUX KI-Bildgenerator - Kostenlos Text zu Bild Online',
        pageDescription: 'FLUX ist ein leistungsstarker KI-Bildgenerator, entwickelt von Black Forest Labs, gegründet vom Team hinter Stable Diffusion. Mit 12 Milliarden Parametern und einzigartigem Design liefert FLUX überlegene visuelle Qualität, Prompt-Genauigkeit und Gesamtleistung. Probieren Sie FLUX kostenlos auf WeryAI aus!',
        pageKeywords: 'FLUX, Black Forest Labs, KI-Bildgenerierung, KI-Kunst, künstliche Intelligenz, Bildbearbeitung, kreativer Ausdruck, Text zu Bild',
        ogTitle: 'FLUX KI-Bildgenerator - Kostenlos Text zu Bild Online',
        ogDescription: 'Erleben Sie den FLUX KI-Bildgenerator, das fortschrittlichste KI-Bildgenerierungsmodell, entwickelt von Black Forest Labs.',
        twitterTitle: 'FLUX KI-Bildgenerator - Kostenlos Text zu Bild Online',
        twitterDescription: 'Erleben Sie den FLUX KI-Bildgenerator, das fortschrittlichste KI-Bildgenerierungsmodell, entwickelt von Black Forest Labs.',
        generatorTitle: 'FLUX KI-Bildgenerator',
        generatorDescription: 'WeryAI integriert jetzt das Modell FLUX tiefgreifend, FLUX ist ein leistungsstarker KI-Bildgenerator, entwickelt von Black Forest Labs, gegründet vom Team hinter Stable Diffusion. Mit 12 Milliarden Parametern und einzigartigem Design liefert FLUX überlegene visuelle Qualität, Prompt-Genauigkeit und Gesamtleistung. Probieren Sie FLUX kostenlos auf WeryAI aus!',
        coreFeaturesTitle: 'FLUX Kernfunktionen',
        coreFeaturesSubtitle: 'Entdecken Sie die Kernfunktionen des FLUX KI-Bildgenerators und begeben Sie sich auf eine revolutionäre KI-Bilderstellungsreise',
        revolutionaryTextToImageTitle: 'Revolutionäre Text-zu-Bild-Technologie',
        revolutionaryTextToImageDescription: 'Generieren Sie hochverfeinerte Bilder in verschiedenen künstlerischen Stilen, während Sie Prompts strikt folgen.',
        creativeExpressionTitle: 'Kreativer Ausdruck',
        creativeExpressionDescription: 'Behalten Sie Charakter- und Szenenelemente über Iterationen hinweg für Konsistenz bei. Aussehen, Merkmale und Stil des Charakters bleiben über beliebig viele generierte Bilder hinweg perfekt vereinheitlicht.',
        advancedStyleControlTitle: 'Erweiterte Stilkontrolle',
        advancedStyleControlDescription: 'Erreichen Sie fortgeschrittene Bildbearbeitung mit reinem Text. Durch einfache Textbeschreibungen können Sie Bilddetails, Farben, Stile und Komposition präzise anpassen.',
        highResolutionTitle: 'Hochauflösende Ausgabe',
        highResolutionDescription: 'Unterstützt Bildgenerierung bis zu 2 Megapixel mit verschiedenen Seitenverhältnissen.',
        fastProcessingTitle: 'Schnelle Verarbeitung',
        fastProcessingDescription: 'Generieren Sie professionelle Bilder in Sekunden. FLUXs optimierte Algorithmen stellen sicher, dass Sie schnell hochwertige Bildergebnisse erhalten und die kreative Effizienz erheblich verbessern.',
        howToUseTitle: 'Wie zu Verwenden',
        howToUseSubtitle: 'Drei einfache Schritte zum Einstieg',
        step1Title: 'Modell Auswählen',
        step1Description: 'Wählen Sie das FLUX-Modell in KI-Bildtools',
        step2Title: 'Inhalt Eingeben',
        step2Description: 'Geben Sie Prompts ein oder laden Sie Referenzbilder hoch',
        step3Title: 'Bild Generieren',
        step3Description: 'Klicken Sie auf die Generieren-Schaltfläche, warten Sie und laden Sie Ihr Bild herunter',
        youtubeTitle: 'YouTube-Videos Über das FLUX KI-Bildmodell',
        xPostsTitle: 'X-Beiträge Über das FLUX KI-Bildmodell',
        exploreModelsTitle: 'Entdecken Sie Andere KI-Bildmodelle auf WeryAI',
        model1Title: 'Google Nano Banana KI-Bildgenerator',
        model2Title: 'Google Imagen KI-Bildgenerator',
        model3Title: 'Qwen Image KI-Bildgenerator',
        faqTitle: 'Häufig Gestellte Fragen',
        faq1Question: 'Was ist FLUX?',
        faq1Answer: 'FLUX ist das fortschrittlichste KI-Bildgenerierungsmodell, entwickelt von Black Forest Labs, mit außergewöhnlicher Bildqualität und kreativen Ausdrucksmöglichkeiten, die professionelle Bilder generieren können.',
        faq2Question: 'Welche Vorteile hat FLUX im Vergleich zu anderen Bildgenerierungsmodellen?',
        faq2Answer: 'FLUX hat bedeutende Vorteile in Bildqualität, kreativem Ausdruck, Stilkontrolle und multimodaler Fusion. Es kann hochwertige professionelle Bilder generieren und unterstützt komplexe kreative Ausdrucksformen.',
        faq3Question: 'Kann ich FLUX kostenlos verwenden?',
        faq3Answer: 'Ja. FLUX bietet begrenzte kostenlose Credits über die kostenlose Testversion von WeryAI an. Für umfangreiche Nutzung ist ein Upgrade erforderlich.',
        faq4Question: 'Welche Bildformate unterstützt FLUX?',
        faq4Answer: 'FLUX unterstützt verschiedene Bildformate, einschließlich JPG, PNG, WEBP und andere gängige Formate. Generierte Bilder zeichnen sich durch hohe Qualität und reichhaltige Details aus.',
        faq5Question: 'Kann ich FLUX für kommerzielle Projekte verwenden?',
        faq5Answer: 'Ja. FLUXs hochpräzise Bildgenerierung und kreative Ausdrucksfähigkeiten machen es zu einer leistungsstarken Wahl für Designer, Künstler und Content-Ersteller, die hochwertige KI-generierte Bilder suchen.',
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Erleben Sie FLUX jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Bilder',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ru: {
        // Русский
        pageTitle: 'Генератор изображений ИИ FLUX - Бесплатно текст в изображение онлайн',
        pageDescription: 'FLUX - это мощный генератор изображений ИИ, разработанный Black Forest Labs, основанной командой, стоящей за Stable Diffusion. С 12 миллиардами параметров и уникальным дизайном FLUX обеспечивает превосходное визуальное качество, точность промптов и общую производительность. Попробуйте FLUX бесплатно на WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, генерация изображений ИИ, ИИ искусство, искусственный интеллект, редактирование изображений, творческое выражение, текст в изображение',
        ogTitle: 'Генератор изображений ИИ FLUX - Бесплатно текст в изображение онлайн',
        ogDescription: 'Откройте для себя генератор изображений ИИ FLUX, самую продвинутую модель генерации изображений ИИ, разработанную Black Forest Labs.',
        twitterTitle: 'Генератор изображений ИИ FLUX - Бесплатно текст в изображение онлайн',
        twitterDescription: 'Откройте для себя генератор изображений ИИ FLUX, самую продвинутую модель генерации изображений ИИ, разработанную Black Forest Labs.',
        generatorTitle: 'Генератор изображений ИИ FLUX',
        generatorDescription: 'WeryAI теперь глубоко интегрировал модель FLUX, FLUX - это мощный генератор изображений ИИ, разработанный Black Forest Labs, основанной командой, стоящей за Stable Diffusion. С 12 миллиардами параметров и уникальным дизайном FLUX обеспечивает превосходное визуальное качество, точность промптов и общую производительность. Попробуйте FLUX бесплатно на WeryAI!',
        coreFeaturesTitle: 'Основные функции FLUX',
        coreFeaturesSubtitle: 'Изучите основные функции генератора изображений ИИ FLUX и отправьтесь в революционное путешествие по созданию изображений ИИ',
        revolutionaryTextToImageTitle: 'Революционная технология текста в изображение',
        revolutionaryTextToImageDescription: 'Создавайте высококачественные изображения в различных художественных стилях, строго следуя промптам.',
        creativeExpressionTitle: 'Творческое выражение',
        creativeExpressionDescription: 'Сохраняйте персонажей и элементы сцены на протяжении итераций для согласованности. Внешний вид, черты и стиль персонажа остаются идеально унифицированными на любом количестве сгенерированных изображений.',
        advancedStyleControlTitle: 'Расширенный контроль стиля',
        advancedStyleControlDescription: 'Достигайте расширенного редактирования изображений с помощью чистого текста. С помощью простых текстовых описаний вы можете точно настраивать детали изображения, цвета, стили и композицию.',
        highResolutionTitle: 'Высокое разрешение вывода',
        highResolutionDescription: 'Поддерживает генерацию изображений до 2 мегапикселей с различными соотношениями сторон.',
        fastProcessingTitle: 'Быстрая обработка',
        fastProcessingDescription: 'Создавайте изображения профессионального уровня за секунды. Оптимизированные алгоритмы FLUX гарантируют быстрое получение высококачественных результатов изображений, значительно повышая творческую эффективность.',
        howToUseTitle: 'Как использовать',
        howToUseSubtitle: 'Три простых шага для начала',
        step1Title: 'Выбрать модель',
        step1Description: 'Выберите модель FLUX в инструментах изображений ИИ',
        step2Title: 'Ввести контент',
        step2Description: 'Введите промпты или загрузите референсные изображения',
        step3Title: 'Сгенерировать изображение',
        step3Description: 'Нажмите кнопку генерации, подождите и скачайте ваше изображение',
        youtubeTitle: 'Видео YouTube о модели изображений ИИ FLUX',
        xPostsTitle: 'Публикации X о модели изображений ИИ FLUX',
        exploreModelsTitle: 'Изучите другие модели изображений ИИ на WeryAI',
        model1Title: 'Генератор изображений ИИ Google Nano Banana',
        model2Title: 'Генератор изображений ИИ Google Imagen',
        model3Title: 'Генератор изображений ИИ Qwen Image',
        faqTitle: 'Часто задаваемые вопросы',
        faq1Question: 'Что такое FLUX?',
        faq1Answer: 'FLUX - это самая продвинутая модель генерации изображений ИИ, разработанная Black Forest Labs, с исключительным качеством изображений и возможностями творческого выражения, способная генерировать изображения профессионального уровня.',
        faq2Question: 'Какие преимущества имеет FLUX по сравнению с другими моделями генерации изображений?',
        faq2Answer: 'FLUX имеет значительные преимущества в качестве изображений, творческом выражении, контроле стиля и мультимодальном слиянии. Он может генерировать высококачественные изображения профессионального уровня и поддерживает сложное творческое выражение.',
        faq3Question: 'Могу ли я использовать FLUX бесплатно?',
        faq3Answer: 'Да. FLUX предлагает ограниченные бесплатные кредиты через бесплатную пробную версию WeryAI. Для расширенного использования требуется обновление.',
        faq4Question: 'Какие форматы изображений поддерживает FLUX?',
        faq4Answer: 'FLUX поддерживает различные форматы изображений, включая JPG, PNG, WEBP и другие распространенные форматы. Сгенерированные изображения отличаются высоким качеством и богатыми деталями.',
        faq5Question: 'Могу ли я использовать FLUX для коммерческих проектов?',
        faq5Answer: 'Да. Высокоточная генерация изображений и возможности творческого выражения FLUX делают его мощным выбором для дизайнеров, художников и создателей контента, ищущих высококачественные изображения, созданные ИИ.',
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Откройте для себя FLUX сейчас и превратите свою креативность в удивительные изображения',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    pt: {
        // Português
        pageTitle: 'Gerador de Imagens IA FLUX - Texto para Imagem Grátis Online',
        pageDescription: 'FLUX é um poderoso gerador de imagens IA desenvolvido pela Black Forest Labs, fundada pela equipe por trás do Stable Diffusion. Com 12 bilhões de parâmetros e design único, FLUX oferece qualidade visual superior, precisão de prompts e desempenho geral. Experimente FLUX gratuitamente no WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, geração de imagens IA, arte IA, inteligência artificial, edição de imagens, expressão criativa, texto para imagem',
        ogTitle: 'Gerador de Imagens IA FLUX - Texto para Imagem Grátis Online',
        ogDescription: 'Experimente o gerador de imagens IA FLUX, o modelo de geração de imagens IA mais avançado desenvolvido pela Black Forest Labs.',
        twitterTitle: 'Gerador de Imagens IA FLUX - Texto para Imagem Grátis Online',
        twitterDescription: 'Experimente o gerador de imagens IA FLUX, o modelo de geração de imagens IA mais avançado desenvolvido pela Black Forest Labs.',
        generatorTitle: 'Gerador de Imagens IA FLUX',
        generatorDescription: 'O WeryAI agora integra profundamente o modelo FLUX, FLUX é um poderoso gerador de imagens IA desenvolvido pela Black Forest Labs, fundada pela equipe por trás do Stable Diffusion. Com 12 bilhões de parâmetros e design único, FLUX oferece qualidade visual superior, precisão de prompts e desempenho geral. Experimente FLUX gratuitamente no WeryAI!',
        coreFeaturesTitle: 'Recursos Principais do FLUX',
        coreFeaturesSubtitle: 'Explore os recursos principais do gerador de imagens IA FLUX e embarque em uma jornada revolucionária de criação de imagens IA',
        revolutionaryTextToImageTitle: 'Tecnologia Revolucionária de Texto para Imagem',
        revolutionaryTextToImageDescription: 'Gere imagens altamente refinadas em vários estilos artísticos enquanto segue estritamente os prompts.',
        creativeExpressionTitle: 'Expressão Criativa',
        creativeExpressionDescription: 'Mantenha personagens e elementos de cena através de iterações para consistência. Aparência, características e estilo do personagem permanecem perfeitamente unificados em qualquer número de imagens geradas.',
        advancedStyleControlTitle: 'Controle de Estilo Avançado',
        advancedStyleControlDescription: 'Alcance edição avançada de imagens com texto puro. Através de descrições de texto simples, você pode ajustar com precisão detalhes da imagem, cores, estilos e composição.',
        highResolutionTitle: 'Saída de Alta Resolução',
        highResolutionDescription: 'Suporta geração de imagens até 2 megapixels com várias proporções de aspecto.',
        fastProcessingTitle: 'Processamento Rápido',
        fastProcessingDescription: 'Gere imagens de nível profissional em segundos. Os algoritmos otimizados do FLUX garantem que você possa obter rapidamente resultados de imagens de alta qualidade, melhorando muito a eficiência criativa.',
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples para começar',
        step1Title: 'Selecionar Modelo',
        step1Description: 'Escolha o modelo FLUX em ferramentas de imagem IA',
        step2Title: 'Inserir Conteúdo',
        step2Description: 'Digite prompts ou carregue imagens de referência',
        step3Title: 'Gerar Imagem',
        step3Description: 'Clique no botão gerar, aguarde e baixe sua imagem',
        youtubeTitle: 'Vídeos do YouTube Sobre o Modelo de Imagem IA FLUX',
        xPostsTitle: 'Publicações X Sobre o Modelo de Imagem IA FLUX',
        exploreModelsTitle: 'Explore Outros Modelos de Imagem IA no WeryAI',
        model1Title: 'Gerador de Imagens IA Google Nano Banana',
        model2Title: 'Gerador de Imagens IA Google Imagen',
        model3Title: 'Gerador de Imagens IA Qwen Image',
        faqTitle: 'Perguntas Frequentes',
        faq1Question: 'O que é FLUX?',
        faq1Answer: 'FLUX é o modelo de geração de imagens IA mais avançado desenvolvido pela Black Forest Labs, com qualidade de imagem excepcional e capacidades de expressão criativa que podem gerar imagens de nível profissional.',
        faq2Question: 'Quais são as vantagens do FLUX em comparação com outros modelos de geração de imagens?',
        faq2Answer: 'FLUX tem vantagens significativas em qualidade de imagem, expressão criativa, controle de estilo e fusão multimodal. Pode gerar imagens de nível profissional de alta qualidade e suporta expressão criativa complexa.',
        faq3Question: 'Posso usar o FLUX gratuitamente?',
        faq3Answer: 'Sim. FLUX oferece créditos gratuitos limitados através do teste gratuito do WeryAI. Para uso extensivo, é necessário um upgrade.',
        faq4Question: 'Quais formatos de imagem o FLUX suporta?',
        faq4Answer: 'FLUX suporta vários formatos de imagem, incluindo JPG, PNG, WEBP e outros formatos comuns. As imagens geradas apresentam alta qualidade e detalhes ricos.',
        faq5Question: 'Posso usar o FLUX para projetos comerciais?',
        faq5Answer: 'Sim. As capacidades de geração de imagens de alta precisão e expressão criativa do FLUX o tornam uma escolha poderosa para designers, artistas e criadores de conteúdo que buscam imagens geradas por IA de alta qualidade.',
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o FLUX agora e transforme sua criatividade em imagens incríveis',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    it: {
        // Italiano
        pageTitle: 'Generatore di Immagini IA FLUX - Testo a Immagine Gratis Online',
        pageDescription: 'FLUX è un potente generatore di immagini IA sviluppato da Black Forest Labs, fondata dal team dietro Stable Diffusion. Con 12 miliardi di parametri e design unico, FLUX offre qualità visiva superiore, precisione dei prompt e prestazioni complessive. Prova FLUX gratuitamente su WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, generazione di immagini IA, arte IA, intelligenza artificiale, modifica di immagini, espressione creativa, testo a immagine',
        ogTitle: 'Generatore di Immagini IA FLUX - Testo a Immagine Gratis Online',
        ogDescription: 'Scopri il generatore di immagini IA FLUX, il modello di generazione di immagini IA più avanzato sviluppato da Black Forest Labs.',
        twitterTitle: 'Generatore di Immagini IA FLUX - Testo a Immagine Gratis Online',
        twitterDescription: 'Scopri il generatore di immagini IA FLUX, il modello di generazione di immagini IA più avanzato sviluppato da Black Forest Labs.',
        generatorTitle: 'Generatore di Immagini IA FLUX',
        generatorDescription: 'WeryAI integra ora in profondità il modello FLUX, FLUX è un potente generatore di immagini IA sviluppato da Black Forest Labs, fondata dal team dietro Stable Diffusion. Con 12 miliardi di parametri e design unico, FLUX offre qualità visiva superiore, precisione dei prompt e prestazioni complessive. Prova FLUX gratuitamente su WeryAI!',
        coreFeaturesTitle: 'Caratteristiche Principali di FLUX',
        coreFeaturesSubtitle: 'Esplora le caratteristiche principali del generatore di immagini IA FLUX e intraprendi un viaggio rivoluzionario nella creazione di immagini IA',
        revolutionaryTextToImageTitle: 'Tecnologia Rivoluzionaria da Testo a Immagine',
        revolutionaryTextToImageDescription: 'Genera immagini altamente raffinate in vari stili artistici seguendo rigorosamente i prompt.',
        creativeExpressionTitle: 'Espressione Creativa',
        creativeExpressionDescription: 'Mantieni personaggi ed elementi di scena attraverso le iterazioni per coerenza. Aspetto, caratteristiche e stile del personaggio rimangono perfettamente unificati su qualsiasi numero di immagini generate.',
        advancedStyleControlTitle: 'Controllo Avanzato dello Stile',
        advancedStyleControlDescription: 'Raggiungi la modifica avanzata delle immagini con testo puro. Attraverso semplici descrizioni testuali, puoi regolare con precisione i dettagli dell\'immagine, i colori, gli stili e la composizione.',
        highResolutionTitle: 'Uscita ad Alta Risoluzione',
        highResolutionDescription: 'Supporta la generazione di immagini fino a 2 megapixel con vari rapporti d\'aspetto.',
        fastProcessingTitle: 'Elaborazione Rapida',
        fastProcessingDescription: 'Genera immagini di livello professionale in pochi secondi. Gli algoritmi ottimizzati di FLUX assicurano di ottenere rapidamente risultati di immagini di alta qualità, migliorando notevolmente l\'efficienza creativa.',
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi per iniziare',
        step1Title: 'Seleziona Modello',
        step1Description: 'Scegli il modello FLUX negli strumenti di immagine IA',
        step2Title: 'Inserisci Contenuto',
        step2Description: 'Inserisci prompt o carica immagini di riferimento',
        step3Title: 'Genera Immagine',
        step3Description: 'Fai clic sul pulsante genera, attendi e scarica la tua immagine',
        youtubeTitle: 'Video YouTube Sul Modello di Immagine IA FLUX',
        xPostsTitle: 'Post X Sul Modello di Immagine IA FLUX',
        exploreModelsTitle: 'Esplora Altri Modelli di Immagine IA su WeryAI',
        model1Title: 'Generatore di Immagini IA Google Nano Banana',
        model2Title: 'Generatore di Immagini IA Google Imagen',
        model3Title: 'Generatore di Immagini IA Qwen Image',
        faqTitle: 'Domande Frequenti',
        faq1Question: 'Cos\'è FLUX?',
        faq1Answer: 'FLUX è il modello di generazione di immagini IA più avanzato sviluppato da Black Forest Labs, con qualità dell\'immagine eccezionale e capacità di espressione creativa che possono generare immagini di livello professionale.',
        faq2Question: 'Quali sono i vantaggi di FLUX rispetto ad altri modelli di generazione di immagini?',
        faq2Answer: 'FLUX ha vantaggi significativi in qualità dell\'immagine, espressione creativa, controllo dello stile e fusione multimodale. Può generare immagini di livello professionale di alta qualità e supporta espressione creativa complessa.',
        faq3Question: 'Posso usare FLUX gratuitamente?',
        faq3Answer: 'Sì. FLUX offre crediti gratuiti limitati attraverso la prova gratuita di WeryAI. Per un uso estensivo, è richiesto un upgrade.',
        faq4Question: 'Quali formati di immagine supporta FLUX?',
        faq4Answer: 'FLUX supporta vari formati di immagine tra cui JPG, PNG, WEBP e altri formati comuni. Le immagini generate presentano alta qualità e dettagli ricchi.',
        faq5Question: 'Posso usare FLUX per progetti commerciali?',
        faq5Answer: 'Sì. Le capacità di generazione di immagini ad alta precisione e di espressione creativa di FLUX lo rendono una scelta potente per designer, artisti e creatori di contenuti che cercano immagini generate da IA di alta qualità.',
        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription: 'Scopri FLUX ora e trasforma la tua creatività in immagini straordinarie',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
    ar: {
        // العربية
        pageTitle: 'مولد صور الذكاء الاصطناعي FLUX - نص إلى صورة مجاني عبر الإنترنت',
        pageDescription: 'FLUX هو مولد صور ذكاء اصطناعي قوي تم تطويره بواسطة Black Forest Labs، التي أسسها الفريق الذي يقف وراء Stable Diffusion. مع 12 مليار معلمة وتصميم فريد، يوفر FLUX جودة بصرية فائقة ودقة في المطالبات وأداء عام. جرب FLUX مجانًا على WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, توليد صور الذكاء الاصطناعي, فن الذكاء الاصطناعي, الذكاء الاصطناعي, تحرير الصور, التعبير الإبداعي, نص إلى صورة',
        ogTitle: 'مولد صور الذكاء الاصطناعي FLUX - نص إلى صورة مجاني عبر الإنترنت',
        ogDescription: 'اكتشف مولد صور الذكاء الاصطناعي FLUX، نموذج توليد الصور بالذكاء الاصطناعي الأكثر تقدمًا الذي طورته Black Forest Labs.',
        twitterTitle: 'مولد صور الذكاء الاصطناعي FLUX - نص إلى صورة مجاني عبر الإنترنت',
        twitterDescription: 'اكتشف مولد صور الذكاء الاصطناعي FLUX، نموذج توليد الصور بالذكاء الاصطناعي الأكثر تقدمًا الذي طورته Black Forest Labs.',
        generatorTitle: 'مولد صور الذكاء الاصطناعي FLUX',
        generatorDescription: 'يقوم WeryAI الآن بدمج نموذج FLUX بعمق، FLUX هو مولد صور ذكاء اصطناعي قوي تم تطويره بواسطة Black Forest Labs، التي أسسها الفريق الذي يقف وراء Stable Diffusion. مع 12 مليار معلمة وتصميم فريد، يوفر FLUX جودة بصرية فائقة ودقة في المطالبات وأداء عام. جرب FLUX مجانًا على WeryAI!',
        coreFeaturesTitle: 'الميزات الأساسية لـ FLUX',
        coreFeaturesSubtitle: 'استكشف الميزات الأساسية لمولد صور الذكاء الاصطناعي FLUX وانطلق في رحلة ثورية لإنشاء صور الذكاء الاصطناعي',
        revolutionaryTextToImageTitle: 'تقنية ثورية من النص إلى الصورة',
        revolutionaryTextToImageDescription: 'أنشئ صورًا عالية التطور بأنماط فنية متنوعة مع الالتزام الصارم بالمطالبات.',
        creativeExpressionTitle: 'التعبير الإبداعي',
        creativeExpressionDescription: 'حافظ على الشخصيات وعناصر المشهد عبر التكرارات لضمان الاتساق. يظل مظهر الشخصية وميزاتها وأسلوبها موحدًا تمامًا عبر أي عدد من الصور المُنشأة.',
        advancedStyleControlTitle: 'التحكم المتقدم في الأسلوب',
        advancedStyleControlDescription: 'حقق تحرير صور متقدم بنص نقي. من خلال أوصاف نصية بسيطة، يمكنك ضبط تفاصيل الصورة والألوان والأنماط والتكوين بدقة.',
        highResolutionTitle: 'إخراج عالي الدقة',
        highResolutionDescription: 'يدعم توليد الصور حتى 2 ميجابكسل بنسب أبعاد مختلفة.',
        fastProcessingTitle: 'معالجة سريعة',
        fastProcessingDescription: 'أنشئ صورًا بمستوى احترافي في ثوانٍ. تضمن خوارزميات FLUX المحسّنة حصولك بسرعة على نتائج صور عالية الجودة، مما يحسن بشكل كبير الكفاءة الإبداعية.',
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة للبدء',
        step1Title: 'اختر النموذج',
        step1Description: 'اختر نموذج FLUX في أدوات صور الذكاء الاصطناعي',
        step2Title: 'أدخل المحتوى',
        step2Description: 'أدخل المطالبات أو قم بتحميل صور مرجعية',
        step3Title: 'إنشاء الصورة',
        step3Description: 'انقر فوق زر الإنشاء، وانتظر وقم بتنزيل صورتك',
        youtubeTitle: 'مقاطع فيديو يوتيوب حول نموذج صور الذكاء الاصطناعي FLUX',
        xPostsTitle: 'منشورات X حول نموذج صور الذكاء الاصطناعي FLUX',
        exploreModelsTitle: 'استكشف نماذج صور الذكاء الاصطناعي الأخرى على WeryAI',
        model1Title: 'مولد صور الذكاء الاصطناعي Google Nano Banana',
        model2Title: 'مولد صور الذكاء الاصطناعي Google Imagen',
        model3Title: 'مولد صور الذكاء الاصطناعي Qwen Image',
        faqTitle: 'الأسئلة الشائعة',
        faq1Question: 'ما هو FLUX؟',
        faq1Answer: 'FLUX هو نموذج توليد الصور بالذكاء الاصطناعي الأكثر تقدمًا الذي طورته Black Forest Labs، ويتميز بجودة صورة استثنائية وقدرات تعبير إبداعي يمكنها توليد صور بمستوى احترافي.',
        faq2Question: 'ما هي مزايا FLUX مقارنة بنماذج توليد الصور الأخرى؟',
        faq2Answer: 'يتمتع FLUX بمزايا كبيرة في جودة الصورة والتعبير الإبداعي والتحكم في الأسلوب والدمج متعدد الوسائط. يمكنه توليد صور بمستوى احترافي عالية الجودة ويدعم التعبير الإبداعي المعقد.',
        faq3Question: 'هل يمكنني استخدام FLUX مجانًا؟',
        faq3Answer: 'نعم. يقدم FLUX أرصدة مجانية محدودة من خلال الإصدار التجريبي المجاني من WeryAI. للاستخدام المكثف، يلزم الترقية.',
        faq4Question: 'ما تنسيقات الصور التي يدعمها FLUX؟',
        faq4Answer: 'يدعم FLUX تنسيقات صور مختلفة بما في ذلك JPG وPNG وWEBP وتنسيقات شائعة أخرى. تتميز الصور المُنشأة بجودة عالية وتفاصيل غنية.',
        faq5Question: 'هل يمكنني استخدام FLUX للمشاريع التجارية؟',
        faq5Answer: 'نعم. تجعل قدرات توليد الصور عالية الدقة والتعبير الإبداعي في FLUX منه خيارًا قويًا للمصممين والفنانين ومنشئي المحتوى الذين يبحثون عن صور عالية الجودة منشأة بالذكاء الاصطناعي.',
        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription: 'اكتشف FLUX الآن وحول إبداعك إلى صور مذهلة',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    th: { 
        // Page title and description
        pageTitle: 'เครื่องมือสร้างภาพ FLUX AI - เปลี่ยนข้อความเป็นภาพออนไลน์ฟรี',
        pageDescription: 'FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        ogDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Twitter Card
        twitterTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        twitterDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Generator section
        generatorTitle: 'เครื่องมือสร้างภาพ FLUX AI',
        generatorDescription: 'ขณะนี้ WeryAI ได้ผสานรวมโมเดล FLUX อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล FLUX อย่างลึกซึ้งแล้ว FLUX เป็นเครื่องมือสร้างภาพ AI ทรงพลังที่พัฒนาโดย Black Forest Labs ก่อตั้งโดยทีมงานผู้อยู่เบื้องหลัง Stable Diffusion ด้วยพารามิเตอร์ 12 พันล้านตัว FLUX มอบคุณภาพของภาพที่เหนือกว่า ความแม่นยำของพรอมต์ และประสิทธิภาพโดยรวม ลองใช้ FLUX ฟรีบน WeryAI!',

        // Core features section
        coreFeaturesTitle: 'ฟีเจอร์หลักของ FLUX',
        coreFeaturesSubtitle: 'Explore the core features of FLUX AI image generator and embark on a revolutionary AI image creation journey',

        // Revolutionary Text-to-Image Technology
        revolutionaryTextToImageTitle: 'เทคโนโลยีข้อความเป็นภาพที่ปฏิวัติวงการ',
        revolutionaryTextToImageDescription: 'Generate highly refined images in various artistic styles while strictly following prompts.',

        // Creative Expression
        creativeExpressionTitle: 'การแสดงออกอย่างสร้างสรรค์',
        creativeExpressionDescription: 'Maintain character and scene elements across iterations for consistency. Character appearance, features, and style remain perfectly unified across any number of generated images.',

        // Advanced Style Control
        advancedStyleControlTitle: 'Advanced Style Control',
        advancedStyleControlDescription: 'Achieve advanced image editing with pure text. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',

        // High Resolution Output
        highResolutionTitle: 'High Resolution Output',
        highResolutionDescription: 'Supports image generation up to 2 megapixels with various aspect ratios.',

        // Fast Processing
        fastProcessingTitle: 'การประมวลผลที่รวดเร็ว',
        fastProcessingDescription: 'Generate professional-grade images in seconds. FLUX\'s optimized algorithms ensure you can quickly obtain high-quality image results, greatly improving creative efficiency.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose FLUX model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About FLUX AI Image Model',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX AI Image Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is FLUX?',
        faq1Answer: 'FLUX is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of FLUX compared to other image generation models?',
        faq2Answer: 'FLUX has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use FLUX for free?',
        faq3Answer: 'Yes. FLUX offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does FLUX support?',
        faq4Answer: 'FLUX supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use FLUX for commercial projects?',
        faq5Answer: 'Yes. FLUX\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience FLUX now and transform your creativity into amazing images',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    da: { // Danish (copied from English)
        // Page title and description
        pageTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        pageDescription: 'FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        ogDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Twitter Card
        twitterTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        twitterDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Generator section
        generatorTitle: 'FLUX AI Image Generator',
        generatorDescription: 'WeryAI har nu integreret modellen FLUX i dybden, FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',

        // Core features section
        coreFeaturesTitle: 'FLUX Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX AI image generator and embark on a revolutionary AI image creation journey',

        // Revolutionary Text-to-Image Technology
        revolutionaryTextToImageTitle: 'Revolutionary Text-to-Image Technology',
        revolutionaryTextToImageDescription: 'Generate highly refined images in various artistic styles while strictly following prompts.',

        // Creative Expression
        creativeExpressionTitle: 'Creative Expression',
        creativeExpressionDescription: 'Maintain character and scene elements across iterations for consistency. Character appearance, features, and style remain perfectly unified across any number of generated images.',

        // Advanced Style Control
        advancedStyleControlTitle: 'Advanced Style Control',
        advancedStyleControlDescription: 'Achieve advanced image editing with pure text. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',

        // High Resolution Output
        highResolutionTitle: 'High Resolution Output',
        highResolutionDescription: 'Supports image generation up to 2 megapixels with various aspect ratios.',

        // Fast Processing
        fastProcessingTitle: 'Fast Processing',
        fastProcessingDescription: 'Generate professional-grade images in seconds. FLUX\'s optimized algorithms ensure you can quickly obtain high-quality image results, greatly improving creative efficiency.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose FLUX model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About FLUX AI Image Model',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX AI Image Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is FLUX?',
        faq1Answer: 'FLUX is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of FLUX compared to other image generation models?',
        faq2Answer: 'FLUX has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use FLUX for free?',
        faq3Answer: 'Yes. FLUX offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does FLUX support?',
        faq4Answer: 'FLUX supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use FLUX for commercial projects?',
        faq5Answer: 'Yes. FLUX\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience FLUX now and transform your creativity into amazing images',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    no: { // Norwegian (copied from English)
        // Page title and description
        pageTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        pageDescription: 'FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        ogDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Twitter Card
        twitterTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        twitterDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Generator section
        generatorTitle: 'FLUX AI Image Generator',
        generatorDescription: 'WeryAI har nå integrert modellen FLUX i dybden, FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',

        // Core features section
        coreFeaturesTitle: 'FLUX Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX AI image generator and embark on a revolutionary AI image creation journey',

        // Revolutionary Text-to-Image Technology
        revolutionaryTextToImageTitle: 'Revolutionary Text-to-Image Technology',
        revolutionaryTextToImageDescription: 'Generate highly refined images in various artistic styles while strictly following prompts.',

        // Creative Expression
        creativeExpressionTitle: 'Creative Expression',
        creativeExpressionDescription: 'Maintain character and scene elements across iterations for consistency. Character appearance, features, and style remain perfectly unified across any number of generated images.',

        // Advanced Style Control
        advancedStyleControlTitle: 'Advanced Style Control',
        advancedStyleControlDescription: 'Achieve advanced image editing with pure text. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',

        // High Resolution Output
        highResolutionTitle: 'High Resolution Output',
        highResolutionDescription: 'Supports image generation up to 2 megapixels with various aspect ratios.',

        // Fast Processing
        fastProcessingTitle: 'Fast Processing',
        fastProcessingDescription: 'Generate professional-grade images in seconds. FLUX\'s optimized algorithms ensure you can quickly obtain high-quality image results, greatly improving creative efficiency.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose FLUX model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About FLUX AI Image Model',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX AI Image Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is FLUX?',
        faq1Answer: 'FLUX is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of FLUX compared to other image generation models?',
        faq2Answer: 'FLUX has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use FLUX for free?',
        faq3Answer: 'Yes. FLUX offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does FLUX support?',
        faq4Answer: 'FLUX supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use FLUX for commercial projects?',
        faq5Answer: 'Yes. FLUX\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience FLUX now and transform your creativity into amazing images',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    nl: { // Dutch (copied from English)
        // Page title and description
        pageTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        pageDescription: 'FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        ogDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Twitter Card
        twitterTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        twitterDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Generator section
        generatorTitle: 'FLUX AI Image Generator',
        generatorDescription: 'WeryAI heeft het model FLUX nu diep geïntegreerd, FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',

        // Core features section
        coreFeaturesTitle: 'FLUX Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX AI image generator and embark on a revolutionary AI image creation journey',

        // Revolutionary Text-to-Image Technology
        revolutionaryTextToImageTitle: 'Revolutionary Text-to-Image Technology',
        revolutionaryTextToImageDescription: 'Generate highly refined images in various artistic styles while strictly following prompts.',

        // Creative Expression
        creativeExpressionTitle: 'Creative Expression',
        creativeExpressionDescription: 'Maintain character and scene elements across iterations for consistency. Character appearance, features, and style remain perfectly unified across any number of generated images.',

        // Advanced Style Control
        advancedStyleControlTitle: 'Advanced Style Control',
        advancedStyleControlDescription: 'Achieve advanced image editing with pure text. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',

        // High Resolution Output
        highResolutionTitle: 'High Resolution Output',
        highResolutionDescription: 'Supports image generation up to 2 megapixels with various aspect ratios.',

        // Fast Processing
        fastProcessingTitle: 'Fast Processing',
        fastProcessingDescription: 'Generate professional-grade images in seconds. FLUX\'s optimized algorithms ensure you can quickly obtain high-quality image results, greatly improving creative efficiency.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose FLUX model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About FLUX AI Image Model',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX AI Image Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is FLUX?',
        faq1Answer: 'FLUX is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of FLUX compared to other image generation models?',
        faq2Answer: 'FLUX has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use FLUX for free?',
        faq3Answer: 'Yes. FLUX offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does FLUX support?',
        faq4Answer: 'FLUX supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use FLUX for commercial projects?',
        faq5Answer: 'Yes. FLUX\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience FLUX now and transform your creativity into amazing images',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    id: { // Indonesian (copied from English)
        // Page title and description
        pageTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        pageDescription: 'FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        ogDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Twitter Card
        twitterTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        twitterDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Generator section
        generatorTitle: 'FLUX AI Image Generator',
        generatorDescription: 'WeryAI kini telah mengintegrasikan model FLUX secara mendalam, FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',

        // Core features section
        coreFeaturesTitle: 'FLUX Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX AI image generator and embark on a revolutionary AI image creation journey',

        // Revolutionary Text-to-Image Technology
        revolutionaryTextToImageTitle: 'Revolutionary Text-to-Image Technology',
        revolutionaryTextToImageDescription: 'Generate highly refined images in various artistic styles while strictly following prompts.',

        // Creative Expression
        creativeExpressionTitle: 'Creative Expression',
        creativeExpressionDescription: 'Maintain character and scene elements across iterations for consistency. Character appearance, features, and style remain perfectly unified across any number of generated images.',

        // Advanced Style Control
        advancedStyleControlTitle: 'Advanced Style Control',
        advancedStyleControlDescription: 'Achieve advanced image editing with pure text. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',

        // High Resolution Output
        highResolutionTitle: 'High Resolution Output',
        highResolutionDescription: 'Supports image generation up to 2 megapixels with various aspect ratios.',

        // Fast Processing
        fastProcessingTitle: 'Fast Processing',
        fastProcessingDescription: 'Generate professional-grade images in seconds. FLUX\'s optimized algorithms ensure you can quickly obtain high-quality image results, greatly improving creative efficiency.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose FLUX model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About FLUX AI Image Model',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX AI Image Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is FLUX?',
        faq1Answer: 'FLUX is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of FLUX compared to other image generation models?',
        faq2Answer: 'FLUX has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use FLUX for free?',
        faq3Answer: 'Yes. FLUX offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does FLUX support?',
        faq4Answer: 'FLUX supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use FLUX for commercial projects?',
        faq5Answer: 'Yes. FLUX\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience FLUX now and transform your creativity into amazing images',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
        },
    tr: { // Turkish (copied from English)
        // Page title and description
        pageTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        pageDescription: 'FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',
        pageKeywords: 'FLUX, Black Forest Labs, AI image generation, AI art, artificial intelligence, image editing, creative expression, text to image',

        // Open Graph
        ogTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        ogDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Twitter Card
        twitterTitle: 'FLUX AI Image Generator - Free Text to Image Online',
        twitterDescription: 'Experience FLUX AI image generator, the most advanced AI image generation model developed by Black Forest Labs.',

        // Generator section
        generatorTitle: 'FLUX AI Image Generator',
        generatorDescription: 'WeryAI artık FLUX modelini derinlemesine entegre ediyor, FLUX is a powerful AI image generator developed by Black Forest Labs, founded by the team behind Stable Diffusion. With 12 billion parameters and unique design, FLUX delivers superior visual quality, prompt accuracy, and overall performance. Try FLUX for free on WeryAI!',

        // Core features section
        coreFeaturesTitle: 'FLUX Core Features',
        coreFeaturesSubtitle: 'Explore the core features of FLUX AI image generator and embark on a revolutionary AI image creation journey',

        // Revolutionary Text-to-Image Technology
        revolutionaryTextToImageTitle: 'Revolutionary Text-to-Image Technology',
        revolutionaryTextToImageDescription: 'Generate highly refined images in various artistic styles while strictly following prompts.',

        // Creative Expression
        creativeExpressionTitle: 'Creative Expression',
        creativeExpressionDescription: 'Maintain character and scene elements across iterations for consistency. Character appearance, features, and style remain perfectly unified across any number of generated images.',

        // Advanced Style Control
        advancedStyleControlTitle: 'Advanced Style Control',
        advancedStyleControlDescription: 'Achieve advanced image editing with pure text. Through simple text descriptions, you can precisely adjust image details, colors, styles, and composition.',

        // High Resolution Output
        highResolutionTitle: 'High Resolution Output',
        highResolutionDescription: 'Supports image generation up to 2 megapixels with various aspect ratios.',

        // Fast Processing
        fastProcessingTitle: 'Fast Processing',
        fastProcessingDescription: 'Generate professional-grade images in seconds. FLUX\'s optimized algorithms ensure you can quickly obtain high-quality image results, greatly improving creative efficiency.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Model',
        step1Description: 'Choose FLUX model in AI image tools',
        step2Title: 'Input Content',
        step2Description: 'Enter prompts or upload reference images',
        step3Title: 'Generate Image',
        step3Description: 'Click generate button, wait and download your image',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About FLUX AI Image Model',

        // X Posts section
        xPostsTitle: 'X Posts About FLUX AI Image Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other AI Image Models on WeryAI',
        model1Title: 'Google Nano Banana AI Image Generator',
        model2Title: 'Google Imagen AI Image Generator',
        model3Title: 'Qwen Image AI Image Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'What is FLUX?',
        faq1Answer: 'FLUX is the most advanced AI image generation model developed by Black Forest Labs, featuring exceptional image quality and creative expression capabilities that can generate professional-grade images.',
        faq2Question: 'What are the advantages of FLUX compared to other image generation models?',
        faq2Answer: 'FLUX has significant advantages in image quality, creative expression, style control, and multi-modal fusion. It can generate high-quality professional-grade images and supports complex creative expression.',
        faq3Question: 'Can I use FLUX for free?',
        faq3Answer: 'Yes. FLUX offers limited free credits through WeryAI\'s free trial. For extensive use, an upgrade is required.',
        faq4Question: 'What image formats does FLUX support?',
        faq4Answer: 'FLUX supports various image formats including JPG, PNG, WEBP and other common formats. Generated images feature high quality and rich detail.',
        faq5Question: 'Can I use FLUX for commercial projects?',
        faq5Answer: 'Yes. FLUX\'s high-precision image generation and creative expression capabilities make it a powerful choice for designers, artists, and content creators seeking high-quality AI-generated images.',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Experience FLUX now and transform your creativity into amazing images',
        ctaButton: 'Try FLUX on WeryAI',
        ctaDisclaimer: 'No credit card required',
    },
}
